<div style="padding: 20px; text-align: center; margin-top: 100px;"
    *ngIf="data?.length === 0 && view == null && !isLoading">
    <img src="../assets/images/question.svg" />
    <div class="no-match" *ngIf="filters.search !== ''"> We didn’t find a match for {{filters.search}}</div>
    <div class="no-match" *ngIf="filters.search === ''">{{message}}</div>
</div>